import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquized: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquized"><Path fillRule="evenodd" clipRule="evenodd" d="M12.75 3V21H11.25V3H12.75ZM5 7.93934L9.06066 12L5 16.0607L3.93934 15L6.18934 12.75H1V11.25H6.18934L3.93934 9L5 7.93934ZM20.0607 9L17.8107 11.25H23V12.75H17.8107L20.0607 15L19 16.0607L14.9393 12L19 7.93934L20.0607 9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquized;
